import {
  Defect,
  DefectPrimaryKeyId,
  DefectReviewStatus
} from 'src/app/models';

export namespace CreateBlank {
  export const defect = (): Defect.Defect => {
    return {
      cloudId: -1 as DefectPrimaryKeyId,
      defectNumberString: 'NEW',
      defectNumber: 0,
      area: '',
      element: '',
      issue: '',
      comments: '',
      created: new Date(),
      completed: undefined,
      dueDate: undefined,
      status: 0,
      priority: 1,
      lastModified: 0,
      reviewStatusId: DefectReviewStatus.NOT_REVIEWED,
      reviewStatus: 'NOT REVIEWED',
    };
  };

  export const defectPhoto = ({
    path,
    cloudId = -1,
    defectId = -1,
    fullPath = '',
    thumbnail = '',
    filename = '',
    createdBy = '',
    created = new Date(),
  }: _CreateBlankDefectPhoto): Defect.Photo => {
    filename = filename || new Date().getTime().toString();
    return {
      cloudId,
      defectId,
      fullPath: fullPath || path || '',
      thumbnail: thumbnail || fullPath || path || '',
      filename: `${filename}.jpeg`,
      createdBy,
      created,
    };
  };
}

interface _CreateBlankDefectPhoto extends Partial<Defect.Photo> {
  path: string;
}
